import {ReactElement} from 'react';
import {StyledAboutBio, StyledAccordion, StyledBody, StyledTitle} from './styles';
import {AboutBioArtistPageProps} from './typings';

const AboutBioArtistPage = ({text, className}: AboutBioArtistPageProps): ReactElement => {
  return (
    <>
      <StyledAboutBio className={className}>
        <StyledTitle>Biography</StyledTitle>

        <StyledBody dangerouslySetInnerHTML={{__html: text}} />
      </StyledAboutBio>

      <StyledAccordion
        title={'Biography'}
        defaultCollapsed={false}
        strongTitle={false}
        className={className}
      >
        <div dangerouslySetInnerHTML={{__html: text}} />
      </StyledAccordion>
    </>
  );
};

export default AboutBioArtistPage;
